<template>
  <!-- Header 组件 -->
  <div class="header" :style="{zIndex: zIndex, background: hColor, color: tColor,fontSize: size, fontWeight:fontWeight, height: height + 'px'}">
    <div class="head-left" v-if="hasBack">
      <slot name="h-left">
        <van-icon class="icon" name="arrow-left" @click="goBack" />
        <p class="left-text" v-if="leftText">{{leftText}}</p>
      </slot>
    </div>
    <div class="head-content">
      <slot name="h-center">
        {{title}}
      </slot>
    </div>
    <div class="head-right">
      <slot name="right">
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'i-header',
  props: {
    title: {
      type: String,
      default: ''
    },
    leftText: {
      type: [String, Boolean],
      default: '返回'
    },
    hColor: {
      type: String,
      default: '#fff'
    },
    tColor: {
      type: String,
      default: '#333'
    },
    size: {
      type: String
    },
    height: {
      type: [String, Number]
    },
    zIndex: {
      type: Number,
      default: 0
    },
    back: {
      type: Function
    },
    hasBack: {
      type: Boolean,
      default: true
    },
    fontWeight:{
        type: Number,
      default:600
    }
  },
  methods: {
    goBack () {
      // console.log('goBack',goBack)
      // console.trace();
      if (this.back) {
        this.back()
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 100;
  font-size: 18px;
  .head-content {
    max-width: 60%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin: 0 auto;
    text-align: center;
    position: relative;
    top: 30%;
  }
  .head-left,
  .head-right {
    font-size: 15px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    padding: 0 10px;
  }
  .head-left {
    left: 0;
    width: 100%;
    .icon{
      font-size: 18px;
      position: relative;
      top:0px;
    }
    .left-text {
      width: 100%;
      text-align: center;
      margin-left: -18px;
      font-size: 16px;
    }
  }
  .head-right {
    right: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/modules/Header/index.vue